module.exports = __webpack_public_path__ + "static/media/logo.d27ba27b.svg";